export const COMPANY_CREATED = "company.created" as const;
export const CONTACT_CREATED = "contact.created" as const;
export const CONTACT_NOTE_CREATED = "contactNote.created" as const;
export const DEAL_CREATED = "deal.created" as const;
export const DEAL_NOTE_CREATED = "dealNote.created" as const;

// Volt: the deals module is not used. false hides it everywhere in the UI;
// the deals table and its data stay untouched.
export const DEALS_ENABLED = false;
